import script from "./CombineOrderConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombineOrderConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./CombineOrderConfirmModal.vue?vue&type=style&index=0&id=4c59a70e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c59a70e"]])

export default __exports__